import { StateTypes } from 'pages/additionalSettings/types';

export const EDITOR_EMPTY_VALUE = '<p><br></p>';

export const FILTER_NETHERLAND_TEMO_TEAM = 'nl-tt';
export const BRAND_TEMPO_TEAM = 'tempo_team';
export const COUNTRY_CODE_NETHERLANDS = 'nl';
export const COUNTRY_CODE_INDIA = 'in';

export const DEFAULT_FILTERS: StateTypes = {
    anonymized: 'no',
    formality: 6,
    instructions: '',
    hasChanged: false,
    length: '175 - 250',
    structures: [1, 2],
    tone_of_voice: 1,
    urgency: 6,
};

export const JOB_GID_QUERY_PARAM_NAME = 'jobgid';

export const IS_EMULATOR_MODE =
    window.location.hostname === 'localhost' && process.env.REACT_APP_DEV_LIVE_MODE !== '1';
